/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `strongly_agree` - Rozhodně ano * `agree` - Spíše ano * `disagree` - Spíše ne * `strongly_disagree` - Rozhodně ne
 */
export type FeelsMoreConfidentEnum = 'strongly_agree' | 'agree' | 'disagree' | 'strongly_disagree';

export const FeelsMoreConfidentEnum = {
    StronglyAgree: 'strongly_agree' as FeelsMoreConfidentEnum,
    Agree: 'agree' as FeelsMoreConfidentEnum,
    Disagree: 'disagree' as FeelsMoreConfidentEnum,
    StronglyDisagree: 'strongly_disagree' as FeelsMoreConfidentEnum
};